module.exports = __webpack_public_path__ + "img/catchbasin_driving.4c871195.svg";